import {useState} from "react";
import {AccountResponseResultModel} from "../../models";
import {getAccountInfoById} from "../../serviceBroker/accountApiServiceBroker";
import {getLabelName} from "../../utils";

const useAccountInfo = (initialAccount: AccountResponseResultModel) => {
    const [currentAccountInfo, setCurrentAccountInfo] =
        useState<AccountResponseResultModel>(initialAccount);

    const [isLoading, setIsLoading] = useState(false);
    const resetCurrentAccountInfo = () => {
        setCurrentAccountInfo({
            ...initialAccount,
            ID: null,
        });
    };

    const fetchAccountInfoByID = async (accountID: number | null) => {
        try {
            if (accountID === null) return setCurrentAccountInfo(initialAccount);
            setIsLoading(true);
            const fetchedAccountInfo = await getAccountInfoById(accountID);
            if (!fetchedAccountInfo.Result) return;
            fetchedAccountInfo.Result.accountTypeName=fetchedAccountInfo.Result.IsParent?getLabelName("Parent Account"):getLabelName("Child Account");
            setCurrentAccountInfo(fetchedAccountInfo.Result);
        } catch (error) {
        } finally {
            setIsLoading(false);
        }
    };
    return {
        currentAccountInfo,
        isAccountInfoLoading: isLoading,
        resetCurrentAccountInfo,
        fetchAccountInfoByID,
    };
};

export default useAccountInfo;
